import { DynamicIcon, flagIconNames } from '@brightlocal/icons/dynamic';
import type { CountryISO3Code } from '@brightlocal/shared';

const flagIconNamesSet = new Set<string>(flagIconNames);

interface Props {
  /** ISO 3166-1 alpha-3 country code used to resolve the corresponding flag icon. Falls back to a globe icon if no matching flag is found. */
  country: CountryISO3Code;
  /** Icon size in pixels. @default 20 */
  size?: number;
}

export const FlagIcon = ({ country, size = 20 }: Props) => {
  const name = flagIconNamesSet.has(country) ? country : 'globe';

  return <DynamicIcon name={name} size={size} />;
};
